<template>
  <div style="padding-bottom: 10px">
    <p class="text-black-50">
      Новый договор
      <i v-on:click="addNewOne" class="tim-icons icon-paper"></i>
    </p>
    <big-one :content="content" :type = "type" :objects="objects" :new-one="newOne"></big-one>
  </div>
</template>
<script>

const name = {header: "Наименование", name: "name", show: true};
const date = {header: "Дата", name: "date", show: true};
const closeDate = {header: "Дата закрытия", name: "closeDate", show: true};

export default{
  props:{
    client: {}
  },
  data() {
    return {
      type: "contract",
      content: [name, date, closeDate],
      objects: [],
      newOne: null
    }
  },
  methods: {
    addNewOne() {
      let object = {name: '', id: 0, client: this.client, document: {pattern: null}};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    }
  },
  async mounted() {
     this.objects = await this.$repo.getByURL('contract/client/' + this.client.id);
  }
}
</script>
<style>
</style>
